function cov_21irm3y2bf() {
  var path = "/app/src/utils/send-segment-event.ts";
  var hash = "4b1f35e454e55770c58b74a2ed9cb66313e38197";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/app/src/utils/send-segment-event.ts",
    statementMap: {
      "0": {
        start: {
          line: 5,
          column: 24
        },
        end: {
          line: 5,
          column: 66
        }
      },
      "1": {
        start: {
          line: 5,
          column: 30
        },
        end: {
          line: 5,
          column: 66
        }
      },
      "2": {
        start: {
          line: 7,
          column: 32
        },
        end: {
          line: 55,
          column: 1
        }
      },
      "3": {
        start: {
          line: 12,
          column: 2
        },
        end: {
          line: 16,
          column: 3
        }
      },
      "4": {
        start: {
          line: 14,
          column: 4
        },
        end: {
          line: 14,
          column: 54
        }
      },
      "5": {
        start: {
          line: 15,
          column: 4
        },
        end: {
          line: 15,
          column: 11
        }
      },
      "6": {
        start: {
          line: 18,
          column: 18
        },
        end: {
          line: 27,
          column: 3
        }
      },
      "7": {
        start: {
          line: 29,
          column: 2
        },
        end: {
          line: 54,
          column: 3
        }
      },
      "8": {
        start: {
          line: 30,
          column: 4
        },
        end: {
          line: 50,
          column: 7
        }
      },
      "9": {
        start: {
          line: 53,
          column: 4
        },
        end: {
          line: 53,
          column: 58
        }
      }
    },
    fnMap: {
      "0": {
        name: "(anonymous_0)",
        decl: {
          start: {
            line: 5,
            column: 24
          },
          end: {
            line: 5,
            column: 25
          }
        },
        loc: {
          start: {
            line: 5,
            column: 30
          },
          end: {
            line: 5,
            column: 66
          }
        },
        line: 5
      },
      "1": {
        name: "(anonymous_1)",
        decl: {
          start: {
            line: 7,
            column: 32
          },
          end: {
            line: 7,
            column: 33
          }
        },
        loc: {
          start: {
            line: 11,
            column: 5
          },
          end: {
            line: 55,
            column: 1
          }
        },
        line: 11
      }
    },
    branchMap: {
      "0": {
        loc: {
          start: {
            line: 12,
            column: 2
          },
          end: {
            line: 16,
            column: 3
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 12,
            column: 2
          },
          end: {
            line: 16,
            column: 3
          }
        }, {
          start: {
            line: undefined,
            column: undefined
          },
          end: {
            line: undefined,
            column: undefined
          }
        }],
        line: 12
      },
      "1": {
        loc: {
          start: {
            line: 12,
            column: 6
          },
          end: {
            line: 12,
            column: 59
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 12,
            column: 6
          },
          end: {
            line: 12,
            column: 31
          }
        }, {
          start: {
            line: 12,
            column: 35
          },
          end: {
            line: 12,
            column: 59
          }
        }],
        line: 12
      }
    },
    s: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0,
      "9": 0
    },
    f: {
      "0": 0,
      "1": 0
    },
    b: {
      "0": [0, 0],
      "1": [0, 0]
    },
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "4b1f35e454e55770c58b74a2ed9cb66313e38197"
  };
  var coverage = global[gcv] || (global[gcv] = {});
  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }
  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_21irm3y2bf = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}
cov_21irm3y2bf();
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i.return) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
import { fetchWithRetry } from 'src/utils/fetch-with-retry';
import { v4 as uuidv4 } from 'uuid';
cov_21irm3y2bf().s[0]++;
var createMessageId = function createMessageId() {
  cov_21irm3y2bf().f[0]++;
  cov_21irm3y2bf().s[1]++;
  return "ajs-next-".concat(Date.now(), "-").concat(uuidv4());
};
cov_21irm3y2bf().s[2]++;
export var sendSegmentEvent = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(event, entityId, properties) {
    var context, _t;
    return _regenerator().w(function (_context) {
      while (1) switch (_context.p = _context.n) {
        case 0:
          cov_21irm3y2bf().f[1]++;
          cov_21irm3y2bf().s[3]++;
          if (!((cov_21irm3y2bf().b[1][0]++, !process.env.SEGMENT_HOST) || (cov_21irm3y2bf().b[1][1]++, !process.env.SEGMENT_KEY))) {
            _context.n = 1;
            break;
          }
          cov_21irm3y2bf().b[0][0]++;
          cov_21irm3y2bf().s[4]++;
          // eslint-disable-next-line no-console
          console.error('Segment configuration is missing');
          cov_21irm3y2bf().s[5]++;
          return _context.a(2);
        case 1:
          cov_21irm3y2bf().b[0][1]++;
        case 2:
          context = (cov_21irm3y2bf().s[6]++, {
            userAgent: navigator.userAgent,
            timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
            locale: navigator.language,
            page: {
              title: document.title,
              url: window.location.href,
              referrer: document.referrer
            }
          });
          cov_21irm3y2bf().s[7]++;
          _context.p = 3;
          cov_21irm3y2bf().s[8]++;
          _context.n = 4;
          return fetchWithRetry({
            url: "https://".concat(process.env.SEGMENT_HOST, "/t"),
            options: {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json'
              },
              keepalive: true,
              body: JSON.stringify({
                anonymousId: entityId,
                type: 'track',
                event: event,
                writeKey: process.env.SEGMENT_KEY,
                properties: properties,
                sentAt: new Date().toISOString(),
                timestamp: new Date().toISOString(),
                context: context,
                messageId: createMessageId()
              })
            }
          });
        case 4:
          _context.n = 6;
          break;
        case 5:
          _context.p = 5;
          _t = _context.v;
          cov_21irm3y2bf().s[9]++;
          // eslint-disable-next-line no-console
          console.error('Failed to send segment event:', _t);
        case 6:
          return _context.a(2);
      }
    }, _callee, null, [[3, 5]]);
  }));
  return function sendSegmentEvent(_x, _x2, _x3) {
    return _ref.apply(this, arguments);
  };
}();